import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";
import {  addNewSubCat,  editSubCat } from "../../services/axios/apiManager";

const AddEditSubCatModal = ({
  selectedSubCategory,
  setSelectedSubCategory,
  showModal,
  setShowModal,
  fetchSubCategories,
  pagination,
  categoriesList,
}) => {
  const [loading, setLoading] = useState(false);
  // // // Close Add Edit Tag Modal
  const handleCloseAddEditModal = () => {
    setSelectedSubCategory({});
    setShowModal(false);
  };
  const catValidations = Yup.object().shape({
    name: Yup.string()
      .trim()
      .min(2, "Sub-Category name must be at least 2 characters")
      .max(100, "Sub-Category name cannot exceed 100 characters")
      .required("Sub-Category name is required"),
    cat_id: Yup.string().trim().required("Category is required"),
  });

  // // Add Edit Role Logic
  const handleAddEditTag = async (data) => {
    if (selectedSubCategory?.id) {
      const editResponse = await editSubCat({
        id: selectedSubCategory.id,
        ...data,
      });
      if (editResponse?.status === 200) {
        if (editResponse?.data?.success) {
          await fetchSubCategories(pagination);

          toast.success("Sub-Category has been updated!", { duration: 2000 });
        }
        handleCloseAddEditModal();
      } else {
        toast.error("Sub-Category has not been updated, try again!", {
          duration: 2000,
        });
      }
    } else {
      const addResponse = await addNewSubCat(data);
      if (addResponse?.status === 200) {
        await fetchSubCategories(pagination);

        toast.success("Sub-Category has been added", {
          duration: 2000,
        });
        handleCloseAddEditModal();
      } else {
        toast.error("Sub-Category has not been added, try again!", {
          duration: 2000,
        });
      }
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>
          {selectedSubCategory?.id ? "Edit Sub-Category" : "Add Sub-Category"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            name: selectedSubCategory?.name || "",
            status: selectedSubCategory?.status,
            cat_id: selectedSubCategory?.cat_id || "",
          }}
          enableReinitialize={true}
          validationSchema={catValidations}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleAddEditTag(values);
            } catch (error) {
              console.log("Error upon Add Update Tag", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Tag Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter tag name"
                  required
                  value={values.name}
                  onChange={handleChange("name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                />
                {errors?.name && touched?.name ? (
                  <span className="text-danger">{errors?.name}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  type="text"
                  value={values.cat_id}
                  onChange={handleChange("cat_id")}
                  className="form-control bg-dark text-light border-light input-placeholder-light"
                >
                  <option value="">Select Category</option>
                  {categoriesList?.map((c) => (
                    <option value={c.id}>{c.name}</option>
                  ))}
                </Form.Select>
                {errors?.cat_id && touched?.cat_id ? (
                  <span className="text-danger">{errors?.cat_id}</span>
                ) : null}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={values.status}
                  onChange={handleChange("status")}
                  className="bg-dark border-light text-light"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </Form.Select>
              </Form.Group>
              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedSubCategory?.id ? "Update" : "Add New Sub-Category"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
export default AddEditSubCatModal;
